
import React, { Component } from 'react';
import "../css/videoYoutube.css"
import axios from "axios";
import { OBTENER_URL_SERVICIO } from "../constants/action-types";
//import { Player, ControlBar } from 'video-react';

class YouTubeVideoXD extends Component {

    constructor(props) {
        super(props);
        this.state = {
            video: "",
            arrayVideos: "",
        }
    }

    async componentDidMount() {
        const response = await axios.get(OBTENER_URL_SERVICIO + "/traerListaVideos");
        await this.setState({
            arrayVideos: response.data,
        })
        const firstVideo = this.state.arrayVideos[0];
        let allVids = this.state.arrayVideos;
        allVids.shift();
        let videosDeCola = allVids.join(",");
        const opts = "https://www.youtube.com/embed/" +
            firstVideo +
            "?autoplay=1" +
            "&modestbranding=1" +
            "&loop=1"+
            "&controls=0" +
            "&disablekb=1" +
            "&playlist=" +
            videosDeCola;

        await this.setState({
            video: <iframe title="videoPantallaYTT" className="playerYT" type="text/html" width="100%" height="100%"
                src={opts}
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                frameBorder="0" />
        })
    }

    render() {
        return (
            <div className="containerYT">
                {this.state.video}
            </div>
        );
    }

}
export default YouTubeVideoXD;
